<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.last_name }"
      )
        .form-elem__title Фамилия
        .form-elem__main
          input.input(
          maxlength="50"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.first_name }"
      )
        .form-elem__title Имя
        .form-elem__main
          input.input(
          maxlength="50"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.fathers_name }"
      )
        .form-elem__title Отчество
        .form-elem__main
          input.input(
          maxlength="50"
          )

    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal
        .form-elem__title Электронная почта
        .form-elem__main
          input.input(
          type="email"
          maxlength="50"
          )
    section.profile-page-form__section.profile-section
      .profile-section__body
        .form
          .form__elem.form__elem_align-right.form__elem_full
            .form-elem
              .form-elem__main
                button.button.button_paint-main
                  .button__text Сохранить изменения

</template>

<script>
export default {
  name: "managers-edit-form",
  props: {
    lastName: {
      type: String,
      default: "",
    },
    firstName: {
      type: String,
      default: "",
    },
    fathersName: {
      type: String,
      default: "",
    },
    gender: {
      type: [Boolean, Object, String],
      default: null,
    },
    dateOfBirth: {
      type: [String, Object],
      default: null,
    },
    placeOfBirth: {
      type: [String, Object],
      default: null,
    },
    requireErrors: {
      type: Object,
      default: () => ({}),
    },
    resetError: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    localLastName: {
      get() {
        return this.lastName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "last_name"]);
      },
    },
    localFirstName: {
      get() {
        return this.firstName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "first_name"]);
      },
    },
    localFathersName: {
      get() {
        return this.fathersName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "fathers_name"]);
      },
    },
    localGender: {
      get() {
        return this.gender;
      },
      set() {},
    },
    localDateOfBirth: {
      get() {
        if (!this.dateOfBirth) {
          return "";
        }
        return this.dateOfBirth;
      },
      set() {},
    },
    localPlaceOfBirth: {
      get() {
        return this.placeOfBirth;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "place_of_birth"]);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    changeGenderValue(e) {
      this.$emit("onChangeValue", [e.target.value === "true", "gender"]);
    },
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.$emit("onChangeValue", [_date, "date_of_birth"]);
      this.resetError("date_of_birth");
    },
  },
};
</script>
